const dpr = global.devicePixelRatio || 1;

const getBackingStorePixelRatio = ctx =>
    ctx.webkitBackingStorePixelRatio ||
    ctx.mozBackingStorePixelRatio ||
    ctx.msBackingStorePixelRatio ||
    ctx.oBackingStorePixelRatio ||
    ctx.backingStorePixelRatio ||
    1;

export const setupCanvas = canvas => {
    const width = (canvas.width = canvas.offsetWidth);
    const height = (canvas.height = canvas.offsetHeight);
    const ctx = canvas.getContext('2d');
    const bsr = getBackingStorePixelRatio(ctx);
    const ratio = dpr / bsr;
    if (ratio !== 1) {
        canvas.width = width * ratio;
        canvas.height = height * ratio;
        ctx.scale(ratio, ratio);
    }
    return {
        width,
        height
    };
};
